import { MasonryPage } from 'components/masonry-page/masonry-page.component';
import { MASONRY } from 'common/constants';

// Pharmacy benefits static page. Entered from two content-managed tiles — one
// on the Benefits landing page, one on Get Care — that deeplink to
// APP_MANAGED_ROUTES.PHARMACY. Rendered entirely OOTB: the whole page is
// server-driven, so nothing here is conditional.
export const PharmacyPage = () => (
  <MasonryPage
    screenName="Pharmacy"
    titleMessageId="STR_PHARMACY"
    rootNodeId={MASONRY.ROOT_NODE_ID_PHARMACY}
  />
);
